import { FC } from 'react';
import { Editor } from '@tiptap/react';
import { Button, Divider } from 'antd';
import { TbBold, TbCode, TbHighlight, TbItalic, TbStrikethrough, TbTypeface, TbUnderline } from 'react-icons/tb';

import TextColorDropdown from '../01-TextColorDropdown';
import HighlightColorDropdown from '../02-HighlightColorDropdown';
import AddLinkDropdown from '../AddLinkDropdown';

interface EditorInlineFormattingControlsProps {
    canUseInlineControls: boolean;
    editor: Editor;
}

const EditorInlineFormattingControls: FC<EditorInlineFormattingControlsProps> = ({
    canUseInlineControls,
    editor,
}): JSX.Element | null => {
    if (!canUseInlineControls) {
        return null;
    }

    return (
        <>
            <TextColorDropdown editor={editor} />
            <HighlightColorDropdown editor={editor} />
            <Divider type='vertical' />
            <Button
                onClick={() => editor.chain().focus().toggleBold().run()}
                className={editor.isActive('bold') ? 'is-active' : ''}
                icon={<TbBold size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderRightColor: 'transparent',
                }}
                type='text'
            />
            <Button
                onClick={() => editor.chain().focus().toggleItalic().run()}
                className={editor.isActive('italic') ? 'is-active' : ''}
                icon={<TbItalic size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                type='text'
            />
            <Button
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                className={editor.isActive('bold') ? 'is-active' : ''}
                icon={<TbUnderline size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderRightColor: 'transparent',
                }}
                type='text'
            />
            <Button
                onClick={() => editor.chain().focus().toggleStrike().run()}
                className={editor.isActive('strike') ? 'is-active' : ''}
                icon={<TbStrikethrough size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderLeftColor: 'transparent',
                }}
                type='text'
            />
            <Button
                onClick={() => editor.chain().focus().toggleCode().run()}
                className={editor.isActive('strike') ? 'is-active' : ''}
                icon={<TbCode size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderLeftColor: 'transparent',
                }}
                type='text'
            />
            <Button
                onClick={() => editor.chain().focus().toggleHighlight().run()}
                className={editor.isActive('strike') ? 'is-active' : ''}
                icon={<TbHighlight size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderLeftColor: 'transparent',
                }}
                type='text'
            />
            <Button
                onClick={() => editor.commands.setCallout('info')}
                icon={<TbTypeface size='1rem' style={{ verticalAlign: '-0.125rem' }} />}
                style={{
                    borderLeftColor: 'transparent',
                }}
                type='text'
            />
            <Divider type='vertical' style={{ height: '1rem', verticalAlign: '-0.325rem' }} />
            <AddLinkDropdown editor={editor} />
            <Divider type='vertical' style={{ height: '1rem', verticalAlign: '-0.325rem' }} />
        </>
    );
};

export default EditorInlineFormattingControls;
